  <div *ngIf="phxPrefixTemplate" class="phx-addon-wrapper-prefix">
    <ng-container [ngTemplateOutlet]="phxPrefixTemplate"></ng-container>
  </div>
  <div class="phx-addon-wrapper-input">
    <ng-content></ng-content>
  </div>
  <div *ngIf="phxSuffixTemplate" class="phx-addon-wrapper-suffix">
    <ng-container [ngTemplateOutlet]="phxSuffixTemplate"></ng-container>
  </div>
